import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-4xl flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 font-heading text-2xl font-bold text-primary-600">
        404
      </span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这一页没有找到
      </h1>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
        链接可能已经调整或者输入有误。你可以回到首页继续浏览，也可以直接从下面的栏目进入。
      </p>
      <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>

      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-home-4-line" />
          </span>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 px-5 py-2.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          使用站内检索
        </Link>
      </div>

      <div className="mt-8 flex flex-wrap justify-center gap-2">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="rounded-full border border-background-300 bg-background-100 px-3.5 py-1.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            {category.name}
          </Link>
        ))}
      </div>
    </div>
  );
}